import { defineStore } from "pinia";

export const useBelajarWajibTerjadwalStore = defineStore({
  id: "belajarWajibTerjadwal",
  state: () => ({
    batchId: "",
    loading: false,
    loadingGetCourses: false,
    loadingGetQuiz: false,
    loadingGetQuizResult: false,
    loadingGetVisitationAssignment: false,
    loadingGetPolicyBriefAssignment: false,
    loadingGetProperReport: false,
    loadingGetAcademicEvaluation: false,
    loadingGetHolidays: false,
    loadingGetAccessToEkosistem: true, // Loading state
    fileName: "",
    fileNameTugas: "",
    courseDetail: {},
    courseList: [],
    kelompok: {},
    detailTugas: {},
    visitationAssignment: {},
    policyBriefAssignment: {},
    quiz: {},
    quizResult: {},
    properReport: {},
    academicEvaluation: {},
    profile: {},
    holidays: [],
    errorGetCourses: false,
    errorGetCourseDetail: false,
    errorGetProfileUser: false,
    errorGetDetailTugas: false,
    errorGetVisitationAssignment: false,
    errorGetPolicyBriefAssignment: false,
    errorGetKelompok: false,
    errorGetQuiz: false,
    errorGetQuizResult: false,
    errorGetProperReport: false,
    errorGetAcademicEvaluation: false,
    errorGetHolidays: false,
  }),
  getters: {
    isLatsarCPNS() {
      const route = useRoute();
      return route.query.isLatsarCPNS === "1";
    },
  },
  actions: {
    async getCourses() {
      this.loadingGetCourses = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          "/dashboard-profile/api/profile/angkatan/filter",
          "GET"
        );
        useBelajarWajibTerjadwalStore().$patch((state) => {
          state.courseList = response;
        });
        this.errorGetCourses = false;
      } catch (error) {
        if (error.response?.status === 401) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetCourses = true;
        }
      } finally {
        this.loadingGetCourses = false;
      }
    },
    async getCourseDetail(batchId) {
      this.loading = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/angkatan/${batchId}`,
          "GET"
        );
        this.courseDetail = response;
        this.loading = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetCourseDetail = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async getViewfilebahan(filename) {
      this.loading = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/file?path=${filename}`,
          "GET"
        );
        useBelajarWajibTerjadwalStore().$patch((state) => {
          state.fileName = !!response ? URL.createObjectURL(response) : "";
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async getViewfilebahanTugas(haveGroup, guid) {
      this.loading = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/${
            haveGroup ? "kelompok-kerja" : "tugas"
          }/${guid}/view${haveGroup ? "-file" : ""}`,
          "GET"
        );
        useBelajarWajibTerjadwalStore().$patch((state) => {
          state.fileNameTugas = !!response ? URL.createObjectURL(response) : "";
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
        }
      } finally {
        this.loading = false;
      }
    },
    getAktivityColor(type) {
      switch (type) {
        case "LURING":
          return "#9ccbc9";
        case "DARING":
          return "#bbb2cc";
        case "VISITASI":
          return "#c0cb9c";
        case "TUGAS":
          return "#cb9ca3";
        case "QUIZ":
          return "#cbae6c";
        case "POLICY_BRIEF":
          return "#c99ccb";
        case "PROPER":
          return "#9cb0cb";
        case "EVALUASI_AKADEMIK":
          return "#c9c99c";
      }
    },
    async getKelompok(aktifitasGuid) {
      this.loading = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/kelompok-kerja/aktifitas/${aktifitasGuid}?isAll=false`,
          "GET"
        );
        this.kelompok =
          Array.isArray(response) && response.length === 0 ? {} : response;
        this.errorGetKelompok = false;
        return response;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
          this.errorGetKelompok = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async getDetailTugas(aktifitasGuid) {
      this.loading = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/tugas/aktifitas/${aktifitasGuid}`,
          "GET"
        );
        this.detailTugas = response;
        this.errorGetDetailTugas = false;
        return response;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          const message = error?.response?._data?.message;
          if (message === "Tugas tidak ditemukan") {
            return;
          }
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack: message || "Terjadi kesalahan.",
          });
          this.errorGetDetailTugas = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async getPolicyBriefAssignment(aktifitasGuid) {
      this.loading = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/policy-brief/activity/${aktifitasGuid}`,
          "GET"
        );
        this.policyBriefAssignment = response;
        this.errorGetPolicyBriefAssignment = false;
        return response;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          const message = error?.response?._data?.message;
          if (message === "Tugas tidak ditemukan") {
            return;
          }
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack: message || "Terjadi kesalahan.",
          });
          this.errorGetPolicyBriefAssignment = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async getVisitationAssignment(aktifitasGuid) {
      this.loading = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/visitasi/${aktifitasGuid}?isAdmin=false`,
          "GET"
        );
        this.visitationAssignment = response;
        this.errorGetVisitationAssignment = false;
        return response;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          const message = error?.response?._data?.message;
          if (message === "Tugas tidak ditemukan") {
            return;
          }
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack: message || "Terjadi kesalahan.",
          });
          this.errorGetVisitationAssignment = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async getQuiz(aktifitasGuid) {
      this.loadingGetQuiz = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/aktifitas/${aktifitasGuid}/quiz`,
          "GET"
        );
        this.quiz = response;
        this.errorGetQuiz = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
          this.errorGetQuiz = true;
        }
      } finally {
        this.loadingGetQuiz = false;
      }
    },
    async getQuizResult(aktifitasGuid) {
      this.loadingGetQuizResult = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/aktifitas/${aktifitasGuid}/quiz/result?isMember=true`,
          "GET"
        );
        this.quizResult = response || {};
        this.errorGetQuizResult = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
          this.errorGetQuizResult = true;
        }
      } finally {
        this.loadingGetQuizResult = false;
      }
    },
    async getProperReport(userGuid, batchGuid) {
      this.loadingGetProperReport = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/proper/api/reports/user?userGuid=${userGuid}&batchGuid=${batchGuid}`,
          "GET"
        );
        this.properReport = response || {};
        this.errorGetProperReport = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
          this.errorGetProperReport = true;
        }
      } finally {
        this.loadingGetProperReport = false;
      }
    },
    async getAcademicEvaluation(batchId) {
      this.loadingGetAcademicEvaluation = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/academic-evaluation/batch/${batchId}`,
          "GET"
        );
        this.academicEvaluation = response;
        this.errorGetAcademicEvaluation = false;
      } catch (error) {
        if (await handleAuthError(error)) return;
        useBelajarWajibStore().$patch({
          snackStatus: "error",
          snackbar: true,
          messageSnack: error?.response?._data?.message || "Terjadi kesalahan.",
        });
        this.errorGetAcademicEvaluation = true;
      } finally {
        this.loadingGetAcademicEvaluation = false;
      }
    },
    async getProfileUser() {
      this.loading = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          "/dashboard-profile/api/profile/getbyuser",
          "GET"
        );
        this.profile = response || {};
        this.errorGetProfileUser = false;
      } catch (error) {
        if (error.response?.status === 401) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetProfileUser = true;
        }
      } finally {
        this.loading = false;
      }
    },
    async getHolidays() {
      this.loadingGetHolidays = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/master-schedule/hari-libur?tahun=2025`,
          "GET"
        );
        this.holidays = response || [];
        this.errorGetHolidays = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetHolidays = true;
        }
      } finally {
        this.loadingGetHolidays = false;
      }
    },
  },
});
